import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { CustomThemeProvider } from "./utils/ThemeContext";
import DateFnsUtils from "@date-io/date-fns";

import * as serviceWorker from "./serviceWorker";

import "./index.css";
import { FeedbackProvider } from "./utils/FeedbackContext";
import Routes from "./Routes";

const history = createBrowserHistory();

ReactDOM.render(
  <CustomThemeProvider>
    <Router history={history}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <FeedbackProvider>
          <Routes />
        </FeedbackProvider>
      </MuiPickersUtilsProvider>
    </Router>
  </CustomThemeProvider>,
  document.getElementById("root")
);

serviceWorker.register();
